import React from 'react'

import { FileParams } from 'components/UploadComponent/FileList'

export interface State {
  uploadedFiles: FileParams[]
  description: string
  submited: boolean
  visibleInPortal: boolean
  expirationEnabled: boolean
  expirationDate: Date | null
  reminderDaysBefore: number
  /** Anexo aguardando confirmação de exclusão; `null` quando não há diálogo aberto. */
  confirmDeleteId: string | null
}

export interface Props {
  uuid?: string
  /**
   * Anexos que o registro já tinha quando a tela abriu. Precisam entrar no estado INTERNO
   * do componente, não só no externo via `setStateExternal`: é o interno que o
   * `handleDelete` consulta para decidir se chama a API, e que o `Upload` usa para
   * respeitar o `maxFiles`. Sem isso, o X de um anexo já salvo apenas o sumia da tela.
   */
  initialFiles?: FileParams[]
  disabled?: boolean
  title?: string | React.ReactNode
  variant?: 'small' | 'normal'
  subTitle?: string
  maxFiles?: number
  submit?: boolean
  description?: boolean
  disabledText?: string
  isLoading?: boolean
  setUploadIsDirty?: React.Dispatch<React.SetStateAction<boolean>>
  accept?: any
  type:
    | 'customers'
    | 'billings'
    | 'onboarding'
    | 'contracts'
    | 'announcement_portals'
    | 'products'
    | 'nfse_issuers'
    | 'accounts_payables'
    | 'other_revenues'
    | 'custom_fields'
    | 'sales_pages'
  noSuppressAuto?: boolean
  docType:
    | 'rg'
    | 'cpf'
    | 'cnpj'
    | 'cnh'
    | 'residency_proof'
    | 'activity_proof'
    | 'receipt'
    | 'other'
    | 'documet_whith_photo'
    | 'import'
    | 'contract'
    | 'documents'
    | 'announcement'
    | 'product_image'
    | 'account_payable'
    | 'nfse'
    | 'terms'
    | 'sales_page'
    | 'selfie'
    | 'cnh_full'
    | 'cnh_front'
    | 'cnh_back'
    | 'rg_front'
    | 'rg_back'
    | 'sales_page'
  sentIcon?: boolean
  resetAfterSubmit?: boolean
  refreshTable?: () => void
  disableList?: boolean
  setStateExternal?: React.Dispatch<React.SetStateAction<FileParams[]>>
  onUploadComplete?: () => void
  setError?: React.Dispatch<React.SetStateAction<boolean>>
  error?: boolean
  setLoadingExternal?: React.Dispatch<React.SetStateAction<boolean>>
  helperText?: string
  showVisibleInPortal?: boolean
  showExpiration?: boolean
  maxSize?: number
  /** Campos extras enviados junto com o arquivo no FormData (ex.: `custom_field_uuid`). */
  extraFormData?: Record<string, string>
  /** Textos do toast quando o arquivo é recusado antes de subir. */
  invalidTypeMessage?: string
  tooManyFilesMessage?: string
}
